// extracted by mini-css-extract-plugin
export default {"voteList":"voteList_voteList__x50Ni","voteListFull":"voteList_voteListFull__oGt6t"};